module.exports = __webpack_public_path__ + "static/media/close-icon.0747ed6e.svg";